import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PcHomeView from '../views/PcHomeView.vue'
import MbHomeView from '../views/MbHomeView.vue'
import AboutUs from '../views/AboutView.vue'
import Agreement from '../views/AgreementView.vue'
import PrivacyPolicy from '../views/PrivacyPolicyView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },{
    path: '/home',
    name: 'pcHome',
    component: PcHomeView
  },{
    path: '/index',
    name: 'mbHome',
    component: MbHomeView
  },{
    path: '/agreement',
    name: 'agreement',
    component: Agreement
  },{
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: PrivacyPolicy
  },{
    path: '/about',
    name: 'aboutUs',
    component: AboutUs
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
